<template>
    <div class="returnPostage">
        <!-- <van-cell-group class="form-input">
            <br />
            <van-field v-model.trim="userInfo.userPhone" required label="手机号：" placeholder="请输入收货手机号：" />
        </van-cell-group> -->
        <section class="section2">
            <em><span>尊敬的客户，您的订单申请预计在1-3个工作日内处理完毕，如遇延迟 请联系客服处理。</span></em>
        </section>
        <section class="section1" v-if="showFlg">
            <ul>
                <li>
                    <label>收货人：</label>
                    <span>{{ orderInfo.name }}</span>
                </li>
                <li>
                    <label>申请时间：</label>
                    <span>{{ orderInfo.createTime }}</span>
                </li>
                <li>
                    <label>申请状态：</label>
                    <span>{{ orderInfo.stateName }}</span>
                </li>
                <li>
                    <label>申请备注：</label>
                    <span>{{ orderInfo.remark }}</span>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'

export default {
    data() {
        return {
            userInfo: {
                userPhone: localStorage.getItem('myLoginPhone'),
            },
            showFlg: false,
            orderInfo: {
                name: '', //收h货姓名
                createTime: '', //申请时间
                stateName: '', //申请状态
                remark: '', //申请备注
            }
        }
    },
    created() {
        this.selectOrderInfo();
    },
    methods: {
        selectOrderInfo() {
            if (this.userInfo.userPhone == '') {
                this.$dialog.alert({ title: '提示', message: '手机号不存在！' });
                return;
            }
            wxRequest("applyChangeSim/select/order/info", this.userInfo, "post").then(res => {
                if (res.data.code == 200) {
                    this.orderInfo = res.data.data;
                    this.showFlg = true;
                } else {
                    this.showFlg = false;
                    this.$dialog.alert({ title: '提示', message: '未查询到收货信息' });
                }
            })
        }
    },

    mounted() {

    },
}
</script>

<style>
.returnPostage .van-field__body {
    height: 100%;
}

.returnPostage .van-button--small {
    height: 35px;
    width: 96%;
    letter-spacing: 1px;
}
</style>

<style lang="less" scoped>
.returnPostage {
    .formLine {
        display: flex;
        margin-top: 10px;
        justify-content: center;
    }

    ::v-deep .section1 {
        margin: 0 10px 10px;
        padding: 10px;
        background: #fff;
        border-radius: 10px;

        ul li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            display: flex;
            justify-content: space-between;

            &:last-child {
                border-bottom: none;
            }

            span {
                color: #FF9C3C;
            }
        }
    }

    .section2 {
        em {
            display: block;
            background: #ff9c3c;
            color: #fff;
            padding: 10px;
            line-height: 1.5em;
        }

        div {
            margin: 10px 0 30px;
            padding: 0 10px;

            input[type=text] {
                border: 1px solid #e0e0e0;
                outline: none;
                padding: 8px;
                line-height: 1.6em;
                width: 100%;
                box-sizing: border-box;
            }
        }

    }
}</style>